<template>
  <div id="password">
    <el-form ref="password" :model="password" :rules="rules" class="input">
      <el-form-item prop="password">
        <el-input type="password" v-model="password.password" placeholder="请输入新密码">
          <template slot="prepend">
            <svg-icon icon-class="password" />
          </template>
        </el-input>
      </el-form-item>

      <el-form-item prop="passwordSure">
        <el-input type="password" v-model="password.passwordSure" placeholder="请确认密码">
          <template slot="prepend">
            <svg-icon icon-class="password" />
          </template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="verifyPassword" class="next-button">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { pbkdf2Hash } from "@/utils/cryptoUtil.js";
import { password, getCheckPasswordValidator } from "@/validator/validator";

export default {
  data() {
    return {
      password: {
        password: "",
        passwordSure: ""
      }
    };
  },

  computed: {
    rules() {
      return {
        password: password,
        passwordSure: getCheckPasswordValidator(this.password.password)
      };
    }
  },

  methods: {
    //设置密码
    async setPassword() {
      const cipherPasswd = await pbkdf2Hash(
        this.password.password,
        this.$parent.phoneNum
      );

      const password = {
        phoneNum: this.$parent.phoneNum,
        passwd: cipherPasswd,
        passwdConfirm: cipherPasswd
      };

      await this.$api.setPassword(password);

      this.setSuccess();
    },

    verifyPassword() {
      this.$refs.password.validate(valid => {
        if (!valid) return false;

        this.setPassword();
      });
    },

    setSuccess() {
      this.$Message.success("密码设置成功！");
      this.$parent.currentStep = 2;
    }
  }
};
</script>
<style lang="scss" scoped>
.next-button {
  width: 100%;
  margin-top: 25px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 4px;
}
</style>
